var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterviewsCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.374,
    height: 14.053,
    viewBox: "0 0 15.374 14.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11204",
    "data-name": "Path 11204",
    d: "M13.933,1.321H12.611V1.2a1.2,1.2,0,0,0-2.4,0v.12H5.165V1.2a1.2,1.2,0,1,0-2.4,0v.12H1.441A1.441,1.441,0,0,0,0,2.763v9.849a1.441,1.441,0,0,0,1.441,1.441H13.933a1.441,1.441,0,0,0,1.441-1.441V2.763A1.441,1.441,0,0,0,13.933,1.321ZM11.17,1.2a.24.24,0,0,1,.48,0V2.642a.24.24,0,1,1-.48,0Zm-7.447,0a.24.24,0,0,1,.48,0V2.642a.24.24,0,1,1-.48,0Zm10.69,11.41a.48.48,0,0,1-.48.48H1.441a.48.48,0,0,1-.48-.48V5.285H14.413Zm0-8.288H.961V2.763a.48.48,0,0,1,.48-.48H2.763v.36a1.2,1.2,0,1,0,2.4,0v-.36h5.045v.36a1.2,1.2,0,0,0,2.4,0v-.36h1.321a.48.48,0,0,1,.48.48Z",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewsCalendarIcon);
export default __webpack_public_path__ + "static/media/interviews-calendar-icon.97e15bb6b4bcaac1a027647bd7a042dc.svg";
export { ForwardRef as ReactComponent };